import React from "react"
import "../../App.less"
import { Button, Form } from "antd"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"

const CalculatorButton = observer(
  ({
    buttonStyle = "btn bttn-lg bttn-primary nextButton st",
    className,
    title,
    onClick,
    type,
    scrn,
    disabled,
    ...props
  }) => {
    const device = AppStore.device
    return (
      <Form.Item className={className}>
        <Button
          htmlType="submit"
          className={buttonStyle}
          // style={device === 0 ? styles[0].buttonForm : styles[1].buttonForm}
          type="primary"
          shape="round"
          size={"large"}
          onClick={() => onClick(scrn)}
          disabled={disabled}
          {...props}
        >
          {title}
        </Button>
      </Form.Item>
    )
  }
)

// const styles = {
//   1: {
//     buttonForm: {
//       width: 211,
//       height: 55,
//     },
//   },
//   0: {
//     buttonForm: {
//       width: 211,
//       height: 47,
//     },
//   },
// }

export default CalculatorButton
